import { clsx } from 'clsx'
import { type FC } from 'react'

import {
  type UserDocumentPosition,
  type UserDocumentPositionERx,
} from '@redteclab/api/clients/bully'

import { userSubOrderAccessorIsProductErx } from '../model/userSubOrderAccessorIsProductErx'

import { OrderImageItem } from './OrderImageItem'

const MAX_ITEMS = 3

export const OrderDetailsProductImageList: FC<{
  products: (UserDocumentPosition & UserDocumentPositionERx)[]
  unlimitedItems?: boolean
}> = ({ products, unlimitedItems }) => {
  const userProducts = unlimitedItems ? products : products.slice(0, MAX_ITEMS)

  return (
    <ul className={clsx('mt-3 flex gap-2', unlimitedItems && 'flex-wrap')}>
      {userProducts.map((item) => {
        if (!item.itemName) {
          return null
        }

        const isErx = userSubOrderAccessorIsProductErx(item)

        return (
          <OrderImageItem
            alt={item.itemName}
            isERx={isErx}
            key={`${isErx ? 'erx-' : ''}${item.itemName}`}
            src={item.thumbnailURL}
          />
        )
      })}
      {!unlimitedItems && products.length > MAX_ITEMS && (
        <div className="flex items-center rounded bg-light-primary-medium px-2 font-medium text-dark-primary-strong">
          <span>{`+${products.length - MAX_ITEMS}`}</span>
        </div>
      )}
    </ul>
  )
}
